import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { Observable, ReplaySubject, Subject } from 'rxjs';
import { GlobalVariableService } from "../variables/global-variable";
import { GlobalService } from './global.service';
import { SC_Input } from "../input/SC_Input";
import { Statics } from '../utilities/statics';
import { TranslateService } from "../variables/translate-service";
import { SC_Beam } from '../roof/SC_Beam';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { ConfirmationBoxComponent } from '../components/confirmation-box/confirmation-box.component';
import { AlertBoxComponent } from '../components/alert-box/alert-box.component';
import { InputBoxComponent } from '../components/input-box/input-box.component';
import { CountryGetAllOutput, CountryData } from "../../common/api/CountryGetAll";
import { InputBase } from '../api/common/InputBase';
import { RoofType } from '../roof/RoofType';
import { MountingType } from '../mountsys/MountingType';
import { MountingSystem } from '../mountsys/MountingSystem';
@Injectable({
    providedIn: 'root'
})
export class GlobalFunctionService {
    selectedProject$: Observable<any[]>;
    roofPlanNameArray: string[] = [];
    private countries$: Subject<CountryData[]>;

    constructor(private store: Store<any>, public dialog: MatDialog, public translate: TranslateService, private global: GlobalVariableService, private globalService: GlobalService) {
        this.selectedProject$ = this.store.select(state => { return state.appData.selectedProject });
        this.selectedProject$.subscribe((data: any) => {
            if (data && data.roofPlans) {
                data.roofPlans.forEach((p: any) => {
                    this.roofPlanNameArray.push(p.name.toLowerCase());
                });
            } else {
                this.roofPlanNameArray = [];
            }
        })
    }

    public checkRoofPlayNameExist(planName: string) {
        return this.roofPlanNameArray && this.roofPlanNameArray.includes(planName.toLocaleLowerCase());
    }

    public checkTrapezDirect() {
        return SC_Input.iRoofType == RoofType.TRAPEZOIDAL && SC_Input.iMountingType == MountingType.DIRECT;
    }

    public checkIntegratedRoof() {
        return SC_Input.iMountSys == MountingSystem.SOL50_PREM_IN || SC_Input.iMountingType == MountingType.DIRECT;
    }

    public getInt(num: string) {
        return parseInt(num);
    }

    public getCountries(): Observable<CountryData[]> {
        if (!this.countries$) {
            const qParam: InputBase = {
                cmd: this.global.CountryGetAll,
            };
            this.countries$ = new ReplaySubject(1);
            this.globalService.getData(qParam).subscribe((data: CountryGetAllOutput) => {
                if (data.ok.data) {
                    this.countries$.next(data.ok.data.countries);
                }
            });
        }
        return this.countries$;
    }


    public getPanelDetail(panelID: number) {
        const qParam = {
            cmd: this.global.PanelGet,
            id: panelID
        };
        return this.globalService.getData(qParam);
    }

    public setPanel(sPanel: any): void {
        SC_Input.sPanel = sPanel;
        //module changed, clear hgroups
        if (SC_Input.aHGroups.length > 0) {
            SC_Input.aHGroups = [];
        }
        SC_Input.nModWidth = sPanel.width;
        SC_Input.nModHeight = sPanel.height;
        SC_Input.nModThick = sPanel.thickness / 10;
        SC_Input.sModulname = sPanel.name;
        SC_Input.sModulID = sPanel.id;
        // SC_Input.nModLeistung = nPanelPerf;
        SC_Input.iModType = sPanel.type;
        SC_Input.sModulImg = sPanel.imageURL;
        SC_Input.sModulPdc = sPanel.Pdc;
    }

    public setProjectMetadata(project: any) {
        SC_Input.sWindzone = project.windZone;
        SC_Input.sSchneezone = project.snowZone;
        SC_Input.sTerrainCat = project.terrainCategory;
        SC_Input.iTerrain = project.terrainHeight;
        if (project.isNorthGermanPlain) {
          SC_Input.isNorthGermanPlain = true;
        } else {
          SC_Input.isNorthGermanPlain = false;
        }
    }

    private num_en2de(sVal: number): String {
        return sVal.toLocaleString('de-DE');
    }

    public openConfirmationBox(code: string, yes?: string, no?: string) {
        const dialogConfig = new MatDialogConfig();
        dialogConfig.data = {
            message: this.translate.getLng(code),
            yes: yes ? this.translate.getLng(yes) : this.translate.getLng('YES'),
            no: no ? this.translate.getLng(no) : this.translate.getLng('NO')
        };
        dialogConfig.disableClose = true;
        dialogConfig.position = { top: '10vh' };
        dialogConfig.maxWidth = '50vw';
        return this.dialog.open(ConfirmationBoxComponent, dialogConfig);
    }

    public openAlertBox(message: string, ok: string) {
        const dialogConfig = new MatDialogConfig();
        dialogConfig.data = {
            message: message,
            ok: ok
        };
        dialogConfig.disableClose = true;
        dialogConfig.position = { top: '10vh' };
        dialogConfig.maxWidth = '50vw';
        return this.dialog.open(AlertBoxComponent, dialogConfig);
    }

    public openInputBox(label: string, message?: string, primary?: string) {
        const dialogConfig = new MatDialogConfig();
        dialogConfig.data = {
            label: label,
            message: message || null,
            primary: primary
        };
        dialogConfig.disableClose = true;
        dialogConfig.maxWidth = '40vw';
        dialogConfig.position = { top: '10vh' }
        return this.dialog.open(InputBoxComponent, dialogConfig);
    }

    public staticDetailToSave() {
        let aData: any[] = [];
        var sTmpF: string, sTmpG: string, sTmpH: string;
        var sModHeight: string = '', sModWidth: string = '';
        sTmpF = this.num_en2de(Statics.oSnowPressure["f"] * 1000) + " Pa";
        sTmpG = this.num_en2de(Statics.oSnowPressure["g"] * 1000) + " Pa";
        sTmpH = this.num_en2de(Statics.oSnowPressure["h"] * 1000) + " Pa";

        SC_Input.planStatics.snowLoadF = Statics.oSnowPressure["f"] * 1000;
        SC_Input.planStatics.snowLoadG = Statics.oSnowPressure["g"] * 1000;
        SC_Input.planStatics.snowLoadH = Statics.oSnowPressure["h"] * 1000;
        aData.push({ name: this.translate.getLng('SNOW_PRES'), f: sTmpF, g: sTmpG, h: sTmpH });

        sTmpF = this.num_en2de(Statics.oWindLoad["f"] * 1000) + " Pa";
        sTmpG = this.num_en2de(Statics.oWindLoad["g"] * 1000) + " Pa";
        sTmpH = this.num_en2de(Statics.oWindLoad["h"] * 1000) + " Pa";

        SC_Input.planStatics.windLoadF = Statics.oWindLoad["f"] * 1000;
        SC_Input.planStatics.windLoadG = Statics.oWindLoad["g"] * 1000;
        SC_Input.planStatics.windLoadH = Statics.oWindLoad["h"] * 1000;
        aData.push({ name: this.translate.getLng('WIND_PRES'), f: sTmpF, g: sTmpG, h: sTmpH });

        sTmpF = this.num_en2de(Statics.oPressureTotal["f"] * 1000) + " Pa";
        sTmpG = this.num_en2de(Statics.oPressureTotal["g"] * 1000) + " Pa";
        sTmpH = this.num_en2de(Statics.oPressureTotal["h"] * 1000) + " Pa";

        SC_Input.planStatics.totalPressureF = Statics.oPressureTotal["f"] * 1000;
        SC_Input.planStatics.totalPressureG = Statics.oPressureTotal["g"] * 1000;
        SC_Input.planStatics.totalPressureH = Statics.oPressureTotal["h"] * 1000;
        aData.push({ name: this.translate.getLng('TOTAL_PRES'), f: sTmpF, g: sTmpG, h: sTmpH });

        sTmpF = this.num_en2de(Statics.oSuction["f"] * 1000) + " Pa";
        sTmpG = this.num_en2de(Statics.oSuction["g"] * 1000) + " Pa";
        sTmpH = this.num_en2de(Statics.oSuction["h"] * 1000) + " Pa";

        SC_Input.planStatics.suctionF = Statics.oSuction["f"] * 1000;
        SC_Input.planStatics.suctionG = Statics.oSuction["g"] * 1000;
        SC_Input.planStatics.suctionH = Statics.oSuction["h"] * 1000;
        aData.push({ name: this.translate.getLng('SUCT_LOAD'), f: sTmpF, g: sTmpG, h: sTmpH });

        //calculated statics
        if (SC_Input.nModHeight > 0) {
            if (SC_Input.iBeamType == SC_Beam.RAFTER) {
                sModHeight = (SC_Input.nModHeight / 10).toString();
                sModWidth = (SC_Input.nModWidth / 10).toString();
            } else if (SC_Input.iBeamType == SC_Beam.PURLIN) {
                sModHeight = (SC_Input.nModWidth / 10).toString();
                sModWidth = (SC_Input.nModHeight / 10).toString();
            }
            if (Statics.oSpanWidthMax["f"] !== undefined) {
                sTmpF = Statics.oSpanWidthMax["f"][sModWidth] == -1 ? "" : Statics.oSpanWidthMax["f"][sModWidth] + " cm";
                sTmpG = Statics.oSpanWidthMax["g"][sModWidth] == -1 ? "" : Statics.oSpanWidthMax["g"][sModWidth] + " cm";
                sTmpH = Statics.oSpanWidthMax["h"][sModWidth] == -1 ? "" : Statics.oSpanWidthMax["h"][sModWidth] + " cm";

                SC_Input.planStatics.maxSpanWidthPortraitF = Statics.oSpanWidthMax["f"][sModWidth] == -1 ? 0 : Statics.oSpanWidthMax["f"][sModWidth];
                SC_Input.planStatics.maxSpanWidthPortraitG = Statics.oSpanWidthMax["g"][sModWidth] == -1 ? 0 : Statics.oSpanWidthMax["g"][sModWidth];
                SC_Input.planStatics.maxSpanWidthPortraitH = Statics.oSpanWidthMax["h"][sModWidth] == -1 ? 0 : Statics.oSpanWidthMax["h"][sModWidth];
                aData.push({ name: this.translate.getLng('USPWMAX_PORT'), f: sTmpF, g: sTmpG, h: sTmpH });

                if (Statics.oCantileverMin["f"] !== undefined) {
                    if (Statics.oCantileverMin["f"][sModWidth] === -1) {
                        sTmpF = "";
                        SC_Input.planStatics.minCantileverPortraitF = 0;
                    } else {
                        sTmpF = Statics.oCantileverMin["f"][sModWidth] + " cm";
                        SC_Input.planStatics.minCantileverPortraitF = Statics.oCantileverMin["f"][sModWidth];
                    }
                    if (Statics.oCantileverMin["g"][sModWidth] === -1) {
                        sTmpG = "";
                        SC_Input.planStatics.minCantileverPortraitG = 0;
                    } else {
                        sTmpG = Statics.oCantileverMin["g"][sModWidth] + " cm";
                        SC_Input.planStatics.minCantileverPortraitG = Statics.oCantileverMin["g"][sModWidth];
                    }
                    if (Statics.oCantileverMin["h"][sModWidth] === -1) {
                        sTmpH = "";
                        SC_Input.planStatics.minCantileverPortraitH = 0;
                    } else {
                        sTmpH = Statics.oCantileverMin["h"][sModWidth] + " cm";
                        SC_Input.planStatics.minCantileverPortraitH = Statics.oCantileverMin["h"][sModWidth];
                    }
                    aData.push({ name: this.translate.getLng('CAN_ARM_MIN_PORT'), f: sTmpF, g: sTmpG, h: sTmpH });
                    if (Statics.oCantileverMin["f"][sModWidth] === -1) {
                        sTmpF = "";
                        SC_Input.planStatics.maxCantileverPortraitF = 0;
                    } else {
                        sTmpF = Statics.oCantileverMax["f"][sModWidth] + " cm";
                        SC_Input.planStatics.maxCantileverPortraitF = Statics.oCantileverMax["f"][sModWidth];
                    }
                    if (Statics.oCantileverMin["g"][sModWidth] === -1) {
                        sTmpG = "";
                        SC_Input.planStatics.maxCantileverPortraitG = 0;
                    } else {
                        sTmpG = Statics.oCantileverMax["g"][sModWidth] + " cm";
                        SC_Input.planStatics.maxCantileverPortraitG = Statics.oCantileverMax["g"][sModWidth];
                    }
                    if (Statics.oCantileverMin["h"][sModWidth] === -1) {
                        sTmpH = "";
                        SC_Input.planStatics.maxCantileverPortraitH = 0;
                    } else {
                        sTmpH = Statics.oCantileverMax["h"][sModWidth] + " cm";
                        SC_Input.planStatics.maxCantileverPortraitH = Statics.oCantileverMax["h"][sModWidth];
                    }
                    aData.push({ name: this.translate.getLng('CAN_ARM_MAX_PORT'), f: sTmpF, g: sTmpG, h: sTmpH });
                }
                sTmpF = Statics.oSpanWidthMax["f"][sModHeight] == -1 ? "" : Statics.oSpanWidthMax["f"][sModHeight] + " cm";
                sTmpG = Statics.oSpanWidthMax["g"][sModHeight] == -1 ? "" : Statics.oSpanWidthMax["g"][sModHeight] + " cm";
                sTmpH = Statics.oSpanWidthMax["h"][sModHeight] == -1 ? "" : Statics.oSpanWidthMax["h"][sModHeight] + " cm";

                SC_Input.planStatics.maxSpanWidthLandscapeF = Statics.oSpanWidthMax["f"][sModHeight] == -1 ? 0 : Statics.oSpanWidthMax["f"][sModHeight];
                SC_Input.planStatics.maxSpanWidthLandscapeG = Statics.oSpanWidthMax["g"][sModHeight] == -1 ? 0 : Statics.oSpanWidthMax["g"][sModHeight];
                SC_Input.planStatics.maxSpanWidthLandscapeH = Statics.oSpanWidthMax["h"][sModHeight] == -1 ? 0 : Statics.oSpanWidthMax["h"][sModHeight];
                aData.push({ name: this.translate.getLng('USPWMAX_LAND'), f: sTmpF, g: sTmpG, h: sTmpH });
                if (Statics.oCantileverMin["f"] !== undefined) {
                    if (Statics.oCantileverMin["f"][sModHeight] === -1) {
                        sTmpF = "";
                        SC_Input.planStatics.minCantileverLandscapeF = 0;
                    } else {
                        sTmpF = Statics.oCantileverMin["f"][sModHeight] + " cm";
                        SC_Input.planStatics.minCantileverLandscapeF = Statics.oCantileverMin["f"][sModHeight];
                    }
                    if (Statics.oCantileverMin["g"][sModHeight] === -1) {
                        sTmpG = "";
                        SC_Input.planStatics.minCantileverLandscapeG = 0;
                    } else {
                        sTmpG = Statics.oCantileverMin["g"][sModHeight] + " cm";
                        SC_Input.planStatics.minCantileverLandscapeG = Statics.oCantileverMin["g"][sModHeight];
                    }
                    if (Statics.oCantileverMin["h"][sModHeight] === -1) {
                        sTmpH = "";
                        SC_Input.planStatics.minCantileverLandscapeH = 0;
                    } else {
                        sTmpH = Statics.oCantileverMin["h"][sModHeight] + " cm";
                        SC_Input.planStatics.minCantileverLandscapeH = Statics.oCantileverMin["h"][sModHeight];
                    }
                    aData.push({ name: this.translate.getLng('CAN_ARM_MIN_LAND'), f: sTmpF, g: sTmpG, h: sTmpH });
                    if (Statics.oCantileverMin["f"][sModHeight] === -1) {
                        sTmpF = "";
                        SC_Input.planStatics.maxCantileverLandscapeF = 0;
                    } else {
                        sTmpF = Statics.oCantileverMax["f"][sModHeight] + " cm";
                        SC_Input.planStatics.maxCantileverLandscapeF = Statics.oCantileverMax["f"][sModHeight];
                    }
                    if (Statics.oCantileverMin["g"][sModHeight] === -1) {
                        sTmpG = "";
                        SC_Input.planStatics.maxCantileverLandscapeG = 0;
                    } else {
                        sTmpG = Statics.oCantileverMax["g"][sModHeight] + " cm";
                        SC_Input.planStatics.maxCantileverLandscapeG = Statics.oCantileverMax["g"][sModHeight];
                    }
                    if (Statics.oCantileverMin["h"][sModHeight] === -1) {
                        sTmpH = "";
                        SC_Input.planStatics.maxCantileverLandscapeH = 0;
                    } else {
                        sTmpH = Statics.oCantileverMax["h"][sModHeight] + " cm";
                        SC_Input.planStatics.maxCantileverLandscapeH = Statics.oCantileverMax["h"][sModHeight];
                    }
                    aData.push({ name: this.translate.getLng('CAN_ARM_MAX_LAND'), f: sTmpF, g: sTmpG, h: sTmpH });
                }
            }
        }
        return aData;
    }

}
